<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from "@/Shared/TextareaInput.vue";
import Pagination from "@/Shared/Pagination.vue";

import {usePaymentsStore} from "@/store/usePaymentsStore";
import {storeToRefs} from "pinia";
import {onMounted, ref} from "vue";
import {useProjectExpensesStore} from "@/store/useExpensesStore";
import CustomPagination from "@/Shared/CustomPagination.vue";

export default {
    props: {
        project: Object,
        members: Object,
        users: Array,
    },
    setup(props) {
        const {payments, filteredPayments} = storeToRefs(usePaymentsStore());
        const {expenses} = storeToRefs(useProjectExpensesStore());

        const id = props.project.id;
        const {fetchPayments} = usePaymentsStore();
        const {fetchExpenses} = useProjectExpensesStore();

        const searchInput = ref('')
        const searchExpensesInput = ref('')


        onMounted(() => {
            fetchPayments(id)
            fetchExpenses(id)
        });


        return {payments, expenses, searchInput, searchExpensesInput}
    },

    components: {
        CustomPagination,
        Pagination,
        TextareaInput,
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
    },
    layout: Layout,

    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                id: this.project.id,
                name: this.project.name,
                user_id: this.project.user_id,
                type: this.project.type,
                address: this.project.address,
                description: this.project.description,
                bedroom: this.project.bedroom,
                bathroom: this.project.bathroom,
                youtube_url: this.project.youtube_url,
                status: this.project.status,
                store: this.project.store,
                latitude: this.project.latitude,
                longitude: this.project.longitude,
                actual_budget: this.project.actual_budget,
                estimated_budget: this.project.estimated_budget,
                size_per_sq_meter: this.project.size_per_sq_meter,
                price: this.project.price,
                kitchen: this.project.kitchen,

            }),
            perPage: 10,
            currentPage: ref(1),
            currentPaymentPage: ref(1),
        }
    },


    methods: {
        update() {
            this.form.put(`/projects/${this.project.id}`)
        },
        destroy() {
            if (confirm('Are you sure you want to delete this Project?')) {
                this.$inertia.delete(`/projects/${this.project.id}`)
            }
        },
        restore() {
            if (confirm('Are you sure you want to restore this Project?')) {
                this.$inertia.put(`/projects/${this.project.id}/restore`)
            }
        },
        formatDate(date) {
            const options = {year: 'numeric', month: 'long', day: 'numeric'}
            return new Date(date).toLocaleDateString('en', options)
        },
        formatNumber(number) {
            return Intl.NumberFormat().format(number);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
        },
        onPaymentPageChange(newPage) {
            this.currentPaymentPage = newPage;
        }


    },

    computed:
        {
            filteredPayments() {
                return this.payments.filter((payment) => {
                    const search = this.searchInput.toLowerCase()
                    return payment.reference.toLowerCase().includes(search) ||
                        payment.amount.toString().includes(search) ||
                        payment.settled_at.includes(search)
                })
            },
            filteredExpenses() {
                return this.expenses.filter((expense) => {
                    const search = this.searchExpensesInput.toLowerCase()
                    return expense.name.toLowerCase().includes(search)
                })
            },

            totalExpenses() {
                return this.filteredExpenses.length
            },
            totalPayments() {
                return this.filteredPayments.length
            },
            totalPaymentPages() {
                return Math.ceil(this.filteredPayments.length / this.perPage)
            },
            paymentsForPage() {
                const startIndex = (this.currentPaymentPage - 1) * this.perPage;
                const endIndex = startIndex + this.perPage;
                return this.filteredPayments.slice(startIndex, endIndex);
            },


            totalPages() {
                return Math.ceil(this.filteredExpenses.length / this.perPage)
            },

            itemsForPage() {
                const startIndex = (this.currentPage - 1) * this.perPage;
                const endIndex = startIndex + this.perPage;
                return this.filteredExpenses.slice(startIndex, endIndex);
            },
        },


}


</script>

<template>
    <div>
        <Head><title>Project- Details</title></Head>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/projects">Project</Link>
                <span class="text-indigo-400 font-medium">/</span> Details
            </h1>
        </div>
        <div class="w-full bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="text-gray-700">
                    <div class="grid md:grid-cols-3 text-sm">

                        <div class="grid">
                            <select-input v-model="form.user_id" :error="form.errors.user_id"
                                          class="px-4 py-2 font-semibold" label="Project Owner">
                                <option v-for="user in users" v-bind:value="user.id">
                                    {{ user.name }}
                                </option>
                            </select-input>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.type" :error="form.errors.type" class="px-4 py-2 font-semibold"
                                        label="Type"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.name" :error="form.errors.name"
                                        class="px-4 py-2 font-semibold"
                                        label="Type"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.address" :error="form.errors.address"
                                        class="px-4 py-2 font-semibold"
                                        label="Address"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.bedroom" :error="form.errors.bedroom"
                                        class="px-4 py-2 font-semibold"
                                        label="No of BedRooms"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.bathroom" :error="form.errors.bathroom"
                                        class="px-4 py-2 font-semibold"
                                        label="No of BathRooms"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.store" :error="form.errors.store"
                                        class="px-4 py-2 font-semibold"
                                        label="No of Stores"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.kitchen" :error="form.errors.kitchen"
                                        class="px-4 py-2 font-semibold"
                                        label="No of kitchen Rooms"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.size_per_sq_meter" :error="form.errors.size_per_sq_meter"
                                        class="px-4 py-2 font-semibold"
                                        label="Size Per Square Meter"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.estimated_budget" :error="form.errors.estimated_budget"
                                        class="px-4 py-2 font-semibold"
                                        label="Estimated Budget"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.actual_budget" :error="form.errors.actual_budget"
                                        class="px-4 py-2 font-semibold"
                                        label="Actual Budget"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.price" :error="form.errors.price"
                                        class="px-4 py-2 font-semibold"
                                        label="Project Price"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.latitude" :error="form.errors.latitude"
                                        class="px-4 py-2 font-semibold"
                                        label="Latitude"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.longitude" :error="form.errors.longitude"
                                        class="px-4 py-2 font-semibold"
                                        label="Longitude"/>
                        </div>
                        <div class="grid ">


                            <select-input v-model="form.status" v-bind:value="form.status"
                                          :error="form.errors.status"
                                          class="px-4 py-2 font-semibold" label="Project Status">
                                <option value="pending">Pending</option>
                                <option value="active">Active</option>
                                <option value="ongoing">Ongoing</option>
                                <option value="completed">Completed</option>
                                <option value="cancelled">Cancelled</option>
                            </select-input>
                        </div>
                        <div class="grid">
                            <text-input v-model="form.youtube_url" :error="form.errors.youtube_url"
                                        class="px-4 py-2 font-semibold"
                                        label="Youtube URL"/>
                        </div>
                        <div class="grid ">
                            <textarea-input v-model="form.description" :error="form.errors.description"
                                            class="px-4 py-2 font-semibold"
                                            label="Description"/>
                        </div>
                        <div class="grid ">
                            <text-input v-model="form.id" :error="form.errors.id"
                                        class="px-4 py-2 font-semibold hidden"
                                        label="id"/>
                        </div>
                    </div>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button v-if="!project.deleted_at" class="text-red-600 hover:underline" tabindex="-1"
                            type="button"
                            @click="destroy">Delete Project
                    </button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update
                        Project
                    </loading-button>
                </div>
            </form>
        </div>

        <div class="my-4"></div>
        <div class="bg-white p-3 shadow-sm rounded-sm">
            <div class="grid ">
                <div>
                    <div class="flex items-center space-x-2 font-semibold text-gray-900 leading-8 mb-3">
                                <span class="text-green-500 flex-none">
                                    <svg class="h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round"
                                                                     stroke-width="2"
                                                                     d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                                    </svg>
                                </span>
                        <span class="tracking-wide flex-1">Expenses</span>


                        <div class='flex-1'>
                            <div
                                class="items-center mb-3  text-black font-normal">
                                <label for="projectpayments-search" class="sr-only">Search</label>
                                <div class="flex bg-white rounded shadow shadow-black-200">
                                    <input type="text" v-model="searchExpensesInput"
                                           class="flex px-10 py-3 md:px-5 rounded-r focus:shadow-outline w-full "
                                           placeholder="Search from Project Expenses">
                                </div>
                            </div>
                        </div>

                    </div>
                    <div v-if="expenses">
                        <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead
                                class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>

                                <th class="py-1 px-2">#</th>
                                <th class="py-1 px-2">Name</th>
                                <th class="py-1 px-2">Category</th>
                                <th class="py-1 px-2">Phase</th>
                                <th class="py-1 px-2">Work Week</th>
                                <th class="py-1 px-2">Material Category</th>
                                <th class="py-1 px-2">Vendor</th>
                                <th class="py-1 px-2">Quantity</th>
                                <th class="py-1 px-2">Unit Cost</th>
                                <th class="py-1 px-2">Total Amount</th>
                                <th class="py-1 px-2">Paid Amount</th>
                                <th class="py-1 px-2">Payment Method</th>

                                <th class="py-1 px-2">Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                                v-for="(expense,index) in itemsForPage" :key="index"
                            >
                                <td
                                    class=" py-1 px-2 ">
                                    {{ index + 1 }}
                                </td>
                                <td
                                    class="py-1 px-2 ">
                                    <Link>
                                        {{ expense.name }}
                                    </Link>
                                </td>
                                <td class="py-2 px-2 ">
                                    <Link>
                                        {{ expense.category.name }}
                                    </Link>
                                </td>
                                <td
                                    class="py-2 px-2 ">
                                    {{ expense.phase }}
                                </td>
                                <td
                                    class="py-2 px-2 ">
                                    {{ expense.work_week }}
                                </td>
                                <td
                                    class="py-1 px-2 ">
                                    {{ expense.material_category }}
                                </td>
                                <td
                                    class="py-1 px-2">
                                    {{ expense.vendor }}
                                </td>
                                <td
                                    class="py-1 px-6 ">
                                    {{ expense.quantity }}
                                </td>
                                <td
                                    class="py-1 px-2 ">
                                    {{ expense.unit_cost }}
                                </td>
                                <td
                                    class="py-1 px-2 ">
                                    {{ expense.total_amount }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ expense.amount_paid }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ expense.payment_method }}
                                </td>
                                <td
                                    class="py-4 px-6">
                                    {{ expense.date }}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <CustomPagination
                            :total-items="totalExpenses"
                            :per-page="perPage"
                            :onPageChange="onPageChange"
                            :total-pages="totalPages"
                            :current-page="currentPage"/>

                    </div>
                    <div v-else>
                        <p
                            class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                            No Expense Data found
                        </p>
                    </div>

                    <button
                        class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                        <a href="/expenses">
                            Load Expenses Page
                        </a>

                    </button>
                </div>
            </div>
        </div>

        <div class="my-4"></div>
        <div class="bg-white p-3 shadow-sm rounded-sm">
            <div class="grid ">
                <div>
                    <div class="flex items-center space-x-2 font-semibold text-gray-900 leading-8 mb-3">
                                <span class="text-green-500 flex-none">
                                    <svg class="h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round"
                                                                     stroke-width="2"
                                                                     d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                                    </svg>
                                </span>
                        <span class="tracking-wide flex-1">Payments</span>


                        <div class='flex-1'>
                            <div
                                class="items-center mb-3  text-black font-normal">
                                <label for="projectpayments-search" class="sr-only">Search</label>
                                <div class="flex bg-white rounded shadow shadow-black-200">
                                    <input type="text" v-model="searchInput"
                                           class="flex px-10 py-3 md:px-5 rounded-r focus:shadow-outline w-full "
                                           placeholder="Search from Project Payments">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="payments">
                        <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead
                                class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>

                                <th class="py-3 px-6">#</th>
                                <th class="py-3 px-6">Reference</th>
                                <th class="py-3 px-6">Amount</th>
                                <th class="py-3 px-6">Buyer</th>
                                <th class="py-3 px-6">Client Amount</th>
                                <th class="py-3 px-6">Organization Amount</th>
                                <th class="py-3 px-6">Split Ratio</th>
                                <th class="py-3 px-6">Settlement Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(payment,index) in paymentsForPage" :key="index"
                                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">

                                <td
                                    class="py-4 px-6 ">
                                    {{ index + 1 }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ payment.reference }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ payment.amount }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ payment.buyer }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ payment.client_amount }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ payment.organization_amount }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ payment.split_ratio }}
                                </td>
                                <td
                                    class="py-4 px-6 ">
                                    {{ formatDate(payment.settled_at) }}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <CustomPagination
                            :total-items="totalPayments"
                            :per-page="perPage"
                            :onPageChange="onPaymentPageChange"
                            :total-pages="totalPaymentPages"
                            :current-page="currentPaymentPage"/>

                    </div>
                    <div v-else>
                        <p
                            class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                            No Payments Data found
                        </p>
                    </div>

                    <button
                        class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                        <a href="/payments">
                            Load Payments Page
                        </a>

                    </button>
                </div>
            </div>
        </div>

        <div class="my-4"></div>
        <div class="bg-white p-3 shadow-sm rounded-sm">

            <div class="flex items-center space-x-2 font-semibold text-gray-900 leading-8 mb-3">
                <span class="text-green-500"><svg class="h-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                                                  viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round"
                                                                                                  stroke-linejoin="round"
                                                                                                  stroke-width="2"
                                                                                                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg></span>
                <span class="tracking-wide">Images</span>
            </div>

            <div class="grid">
                <div v-if="project.media.length  > 0">
                    <div v-for="image in project.media" :key="image.id">
                        <div class="flex flex-wrap justify-center"><img v-if="image && image.original_url"
                                                                        :src="image.original_url"
                                                                        class="p-1 bg-white border rounded max-w-sm"
                                                                        alt="..."/></div>
                    </div>
                </div>
                <div v-else>
                    <p
                        class="block w-full text-red-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                        This Project has no Images Provided
                    </p>

                </div>
            </div>

        </div>
    </div>
</template>
